import SvgIcon from './SvgIcon';

const PageViewIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 17">
    <defs>
      <linearGradient
        x1="50%"
        y1="-8.888%"
        x2="50%"
        y2="86.873%"
        id="pageViewIcon-c">
        <stop stopColor="#3F81C1" offset="0%" />
        <stop stopColor="#6174BF" offset="100%" />
      </linearGradient>
      <path
        d="M10 17C3.888 17 .852 12.258.096 10.875a.778.778 0 0 1 0-.75C.852 8.742 3.888 4 10 4s9.148 4.742 9.904 6.125a.777.777 0 0 1 0 .75C19.148 12.258 16.112 17 10 17zm.006-10.969c-2.53 0-4.58 2.001-4.58 4.47 0 2.467 2.05 4.468 4.58 4.468 2.53 0 4.582-2.001 4.582-4.469a4.414 4.414 0 0 0-1.342-3.16 4.64 4.64 0 0 0-3.24-1.31v.001zm0 7.313c-1.61 0-2.915-1.273-2.915-2.844 0-1.57 1.305-2.843 2.915-2.843s2.916 1.273 2.916 2.843-1.306 2.844-2.916 2.844z"
        id="pageViewIcon-b"
      />
      <filter
        x="-17.5%"
        y="-19.2%"
        width="135%"
        height="153.8%"
        filterUnits="objectBoundingBox"
        id="pageViewIcon-a">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation="1"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0.231469425 0 0 0 0 0.304499662 0 0 0 0 0.488334396 0 0 0 0.219316123 0"
          in="shadowBlurOuter1"
        />
      </filter>
    </defs>
    <g transform="translate(2 -3)" fill="none" fillRule="evenodd">
      <use fill="black" filter="url(#pageViewIcon-a)" href="#pageViewIcon-b" />
      <use fill="url(#pageViewIcon-c)" href="#pageViewIcon-b" />
    </g>
  </SvgIcon>
);

PageViewIcon.defaultProps = {
  height: 24,
  width: 17,
};

PageViewIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
};

export default PageViewIcon;
